import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { motion } from "framer-motion";
import { api } from "../lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");
  const email = params.get("email") || "";

  useEffect(() => {
    const token = params.get("token");
    if (!email || !token) {
      setStatus("error");
      setError("This unsubscribe link is incomplete.");
      return;
    }
    (async () => {
      try {
        await api.post("/customers/unsubscribe", { email, token });
        setStatus("ok");
      } catch (e) {
        setStatus("error");
        setError(e?.response?.data?.detail || "We couldn't process this link.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="App min-h-screen flex items-center justify-center"
      data-testid="unsubscribe-page"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center px-6 max-w-md"
      >
        {status === "loading" && (
          <>
            <Loader2
              className="mx-auto animate-spin mb-6"
              size={28}
              style={{ color: "var(--mek-accent)" }}
            />
            <p className="font-serif text-2xl">Updating your preferences…</p>
          </>
        )}
        {status === "ok" && (
          <div data-testid="unsubscribe-ok">
            <CheckCircle2
              className="mx-auto mb-6"
              size={32}
              style={{ color: "#4A613F" }}
            />
            <p className="font-serif text-2xl mb-3">You're unsubscribed.</p>
            <p className="text-prose mb-2">
              {email
                ? `We won't send new-scenario emails to ${email} anymore.`
                : "We won't send new-scenario emails to you anymore."}
            </p>
            <p className="text-prose text-sm" style={{ color: "var(--mek-text-3)" }}>
              You'll still receive transactional emails (access links, receipts).
              Your toolkit access is unchanged.
            </p>
          </div>
        )}
        {status === "error" && (
          <div data-testid="unsubscribe-error">
            <AlertCircle
              className="mx-auto mb-6"
              size={28}
              style={{ color: "#8B3E3E" }}
            />
            <p className="font-serif text-2xl mb-3">This link can't be used.</p>
            <p className="text-prose mb-2">{error}</p>
            <p
              className="text-prose text-sm"
              style={{ color: "var(--mek-text-3)" }}
            >
              If you'd still like to unsubscribe, reply to any toolkit email and
              I'll take care of it directly.
            </p>
          </div>
        )}
      </motion.div>
    </div>
  );
}
